module.exports = __webpack_public_path__ + "static/media/guille.5b7cdb3d.jpg";